.nav-bar {
  margin-top: 0;
}

.tab-bar {
  margin-top: 20px;
  user-select: none;
}
